<template>
  <div class="result w-full bg-white px-4 py-6">
    <h1 class="font-semibold text-xl mb-3">
      Imunisasi Rutin<span v-if="route.query.stage === 'bayi' || route.query.stage === 'balita'"> (0-18 Bulan)</span>
    </h1>
    <!-- LIST IMUNISASI -->
    <div v-for="(item, index) in masterImunization" :key="`itemParent-${index}`">
      <p class="text-base mb-3 mt-5 font-semibold">{{ item.text }}</p>
      <div v-for="(item2, index2) in item.list" :key="`itemList-${index}-${index2}`" class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">{{ item2.name }}</p>
          <Checked v-if="item2.value" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
    </div>

    <Loading v-show="loading" class="top-0 left-0 bg-[rgba(0,0,0,0.25)]"/>
  </div>
</template>

<script setup>
import {
  ref,
} from 'vue';

import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import Loading from '@/components/LoadingOverlay.vue';
import Checked from '@/components/icons/Checked.vue';
import Unchecked from '@/components/icons/Unchecked.vue';

const store = useStore();
const route = useRoute();

const masterImunization = ref([]);
const loading = ref(false);

async function getImunization() {
  loading.value = true;
  const master = await store.dispatch('screening/getMasterImunization', route.query.stage);
  const imun = await store.dispatch('screening/getImunization', {
    token: route.query.token,
    dob: store.state.global.dob,
  });

  // deep clone master so when the temp si modified, the original wont be affected
  const tempMaster = structuredClone(master);

  /* set value true based on imunization result */

  if (master?.length) {
    if (imun?.length) {
      imun.forEach((item) => {
        Object.keys(tempMaster).every((key) => {
          if (master[key].id === item.imunizationId) {
            master[key].value = true;
            // deleting object so it wont be looped back
            delete tempMaster[key];
            return false;
          }
          return true;
        });
      });
    }

    /* grouping by months */
    if (route.query.stage === 'bayi' || route.query.stage === 'balita') {
      const imunGroup = Object.groupBy(master, ({ months }) => months);
      masterImunization.value[0] = {
        text: 'Usia 0 Bulan - 1 Bulan',
        list: [...imunGroup[0], ...imunGroup[1]],
      };
      Object.keys(imunGroup).forEach((key, index) => {
        if (key !== '0' && key !== '1') {
          masterImunization.value.push({
            text: `Usia ${key} Bulan`,
            list: imunGroup[key],
          });
        }
      });
    } else {
      const imunGroup = Object.groupBy(master, ({ titleGroup }) => titleGroup);
      Object.keys(imunGroup).forEach((key, index) => {
        masterImunization.value.push({
          text: `${key}`,
          list: imunGroup[key],
        });
      });
    }
    loading.value = false;
  } else {
    loading.value = false;
  }
}
getImunization();
</script>

<script>
export default {
  name: 'ImunizationView',
};
</script>

<style lang="scss" scoped>
</style>
